<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 12 12"
  >
    <g fill="none" fill-rule="evenodd">
      <g>
        <path fill="#DAE2FB" d="M6 0L2 5 10 5z" />
        <path
          fill="#0074FF"
          d="M6 7L2 12 10 12z"
          transform="matrix(1 0 0 -1 0 19)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'SortDescIcon',
  props: {
    height: VueTypes.string.def('12'),
    width: VueTypes.string.def('12'),
  },
};
</script>

<style lang="scss"></style>
